import { Box, BoxProps, Flex, Heading, Icon, Image, useBreakpointValue } from '@chakra-ui/react';
import { FC, useState } from 'react';

import LockIconOpen from '@/assets/icons/ic-lock-open.svg';
import LockIcon from '@/assets/icons/ic-lock.svg';

import { FlippedLectureCard } from '@/components/ui/shared/lecture/FlippingLectureCardOmnisearch/components/FlippedLectureCard';
import { LectureAuthorsText } from '@/components/ui/shared/lecture/FlippingLectureCardOmnisearch/components/LectureAuthorsText';
import { LectureCardAwardCircleTooltip } from '@/components/ui/shared/lecture/LectureAwardCircleTooltip/LectureCardAwardCircleTooltip';
import { OmnisearchThinLecture } from '@/resources/OmnisearchThinLecture';
import { LECTURE_CARD_IMAGE_FALLBACK } from '@/utils/constants';

interface IFlippingLectureCardProps extends BoxProps {
  lecture: OmnisearchThinLecture;
}
export const FlippingLectureCardOmnisearch: FC<IFlippingLectureCardProps> = ({ lecture, ...rest }) => {
  const [isFlipped, setIsFlipped] = useState(false);
  const screenSize = useBreakpointValue({ base: 'sm', md: 'md' }, { ssr: true, fallback: 'md' });

  const isMobile = screenSize === 'sm';

  const posterThumbnail = lecture.mediumPosterDocumentThumbnailUrl || lecture.mediumPosterDocumentThumbnailExtractUrl;

  const imageSrc = lecture.posterLecture
    ? posterThumbnail || lecture.mediumPosterUrl || lecture.event.mediumPosterFallbackImageUrl
    : lecture.mediumPosterUrl || posterThumbnail || lecture.event.mediumVideoFallbackImageUrl;

  return (
    <Box
      onMouseEnter={() => !isMobile && setIsFlipped(true)}
      onMouseLeave={() => !isMobile && setIsFlipped(false)}
      onClick={() => isMobile && setIsFlipped((f) => !f)}
      backgroundColor="white"
      overflow="hidden"
      borderRadius="8"
      w={{ base: '335px', lg: '389.3px' }}
      h="320px"
      {...rest}
    >
      {!isFlipped && (
        <Box position="relative">
          <Image
            objectFit="cover"
            src={imageSrc || LECTURE_CARD_IMAGE_FALLBACK}
            alt={lecture.title}
            w="full"
            h="219px"
          />
          <Box position="absolute" top={2} right={2}>
            <LectureCardAwardCircleTooltip award={lecture.awards} />
          </Box>
          <Box minH={{ base: '54px', md: '74px' }} color="gray.800" px="4" mt="4">
            <Heading mb="1" color="black" lineHeight={6} noOfLines={2} fontSize="m">
              {lecture.title}
            </Heading>

            <Flex justifyContent="space-between" alignItems="center">
              <LectureAuthorsText profiles={lecture.positionSortedProfiles} />
              <Icon
                as={lecture?.accessRestricted ? LockIcon : LockIconOpen}
                h={6}
                w={6}
                color={lecture?.accessRestricted ? 'gray.500' : 'teal.500'}
              />
            </Flex>
          </Box>
        </Box>
      )}
      {isFlipped && <FlippedLectureCard lecture={lecture} />}
    </Box>
  );
};
